import { Injectable } from "@angular/core";
import { template } from "lodash-es";
import { AppPoundsPipe } from "../components/shared/pipes/app-pounds-pipe";

declare type TemplateExecutor = ReturnType<typeof template>;
@Injectable({
  providedIn: 'root'
})
export class InterpolationService {
  private _cache = new Map<string, TemplateExecutor>();

  constructor(
    private poundsPipe: AppPoundsPipe
  ) {
  }

  public interpolate(text: string, parameters: any): string {
    if (!text) return null;

    let executor = this._cache.get(text);
    if (!executor) {
      executor = template(text, { interpolate: /{{([\s\S]+?)}}/g });
      this._cache.set(text, executor);
    }

    return executor({
      ...parameters,
      pounds: this.poundsPipe.transform
    });
  }

}
